import { isSupabaseEnabled, supabase } from './supabaseClient';

const FALLBACK_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
const FALLBACK_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;

function verifyWithEnv(email, password) {
  if (!FALLBACK_EMAIL || !FALLBACK_PASSWORD) return false;
  return (
    email.trim().toLowerCase() === FALLBACK_EMAIL.toLowerCase() &&
    password === FALLBACK_PASSWORD
  );
}

export async function verifyAdminCredentials(email, password) {
  const normalizedEmail = email?.trim().toLowerCase() || '';
  const normalizedPassword = password?.trim() || '';

  if (!normalizedEmail || !normalizedPassword) {
    return { ok: false, error: 'Invalid email or password.' };
  }

  if (isSupabaseEnabled()) {
    const { data, error } = await supabase.rpc('verify_admin_login', {
      p_email: normalizedEmail,
      p_password: normalizedPassword,
    });

    if (error) {
      console.error('Supabase login check failed:', error);
      return {
        ok: false,
        error: 'Unable to verify sign in right now. Please try again in a moment.',
      };
    }

    if (data) {
      return { ok: true };
    }

    return { ok: false, error: 'Invalid email or password.' };
  }

  if (verifyWithEnv(normalizedEmail, normalizedPassword)) {
    return { ok: true };
  }

  return { ok: false, error: 'Invalid email or password.' };
}
